import Cookies from "js-cookie";
import Lottie from "lottie-react";
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Tooltip from "react-bootstrap/Tooltip";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Zoom from "react-reveal/Zoom";
import { useLocation, useParams } from "react-router-dom";
import socket from "../../Socket";
import arrow2 from "../assets/arrow1.png";
import img1 from "../assets/position-trophy.png";
import img from "../assets/image 10.png";
import Animate from "../assets/loader.json";
import flag from "../assets/United Arab Emirates.png";
import "../Components/CSS/RaceCardCSS/racedetail.css";
import CastModal from "../Components/Modal/CastModal";
import VideoFrame from "../Components/Modal/VideoFrame";
import CardData from "../Components/RaceCard/Card";
import Draw from "../Components/RaceCard/Draw";
import Predictor from "../Components/RaceCard/Predictor";
import AiAnalysis from "../Components/RaceCard/AiAnalysis";
import PrintOut from "../Components/RaceCard/Printout";
import Summary from "../Components/RaceCard/Summary";
import TrackRecord1 from "../Components/RaceCard/TrackRecord";
import RaceNumbers from "../Components/Reuseable/RaceNumbers";
import { fetchDraw } from "../redux/getReducer/getDraw";
import { fetchRacePredictor } from "../redux/getReducer/getRacePrediction";
import { fetchRaceAiAnalysis } from "../redux/getReducer/getRaceAiAnalysis";
import { fetchsinglerace, STATUSES } from "../redux/getReducer/getSingleRace";
import { fetchSummary } from "../redux/getReducer/getSummarySlice";
import { fetchTrackRecord } from "../redux/getReducer/TrackRecord";
import { Button } from "react-bootstrap";
import Defaultimg from "../assets/Gif1000/Mey1200Dirt.gif";
import Defaultimg2 from "../assets/image not found.png";
import { useReactToPrint } from 'react-to-print';
const RaceCardDetail = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Print-Report",
  });

  // const { id } = useParams();
  const location = useLocation();
  const id = location.search.slice(1);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: singlerace, status } = useSelector((state) => state.singlerace);
  const { data: RacePredictor } = useSelector((state) => state.RacePredictor);
  const { data: draw } = useSelector((state) => state.draw);
  const { data: summary } = useSelector((state) => state.summary);
  const { data: TrackRecord } = useSelector((state) => state.TrackRecord);
  const {
    data: raceAiAnalysis,
    status: aiAnalysisStatus,
    errorMessage: aiAnalysisErrorMessage,
  } = useSelector(
    (state) => state.raceAiAnalysis
  );
  const { data: ThemeSetting } = useSelector((state) => state.ThemeSetting);

  const [shows, setShows] = useState(false);

  const handleClosed = () => setShows(false);
  const handleShowed = () => setShows(true);

  const token = Cookies.get("token");
  const myRef = useRef(null);
  useEffect(() => {
    // Scroll to the component when the component mounts
    if (myRef.current) {
      myRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const [show, setShow] = useState(false);
  const [castdependency, setcastdependency] = useState(false);
  const [modaldata, setmodaldata] = useState();
  const handleClose = () => setShow(false);
  const handleShow = async (data) => {
    setmodaldata(data);
    await setShow(true);
  };

  const [showCast, setShowCast] = useState(false);
  const [modaldataCast, setmodaldataCast] = useState();
  const handleCloseCast = () => {
    setShowCast(false);
    setcastdependency(true);
  };
  const handleShowCast = async (data) => {
    setmodaldataCast(data);
    await setShowCast(true);
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const toTitleCase = (str) => {
    if (!str) return "-";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  useEffect(() => {
    const scrollY = window.innerWidth <= 530 ? 1500 : 1000;
    window.scrollTo({ top: scrollY, behavior: "smooth" });
  }, []);

  const btnNew1 = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px",
    gap: "10px",
    width: "112px",
    height: "24px",
    background: "#FF0000",
    border: "none",
    color: "#fff",
  };

  const btnNewdelete = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px",
    gap: "10px",
    width: "112px",
    marginTop: "10px",
    height: "24px",
    background: "#19469D",
    border: "none",
    color: "#fff",
  };
  const [activeTab, setActiveTab] = useState("Card");

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    if (tabIndex == "Predictor") {
      dispatch(fetchRacePredictor({ id }));
      socket.emit("createRoom", id);
    } else if (tabIndex == "Draw") {
      dispatch(fetchDraw({ id }));
      socket.emit("leaveroom", id);
    } else if (tabIndex == "Summary") {
      dispatch(fetchSummary({ id }));
    } else if (tabIndex == "Track Record") {
      dispatch(fetchTrackRecord({ id }));
    } else if (tabIndex == "RAAS AI" || tabIndex == "AI Analysis") {
      dispatch(fetchRaceAiAnalysis({ id }));
    } else if (tabIndex == "Printout") {
    }
  };

  useEffect(() => {
    dispatch(fetchsinglerace({ id }));
    setActiveTab("Card");
  }, [dispatch, id, castdependency]);

  if (status === STATUSES.ERROR) {
    return (
      <h2 style={{ margin: "100px", width: "50%" }}>
        {t("Something went wrong!")}
      </h2>
    );
  }

  const cookiedata = Cookies.get("i18next");

  const DataDate = new Date(
    singlerace.racedetail && singlerace.racedetail.StartTime === null
      ? ""
      : singlerace.racedetail && singlerace.racedetail.StartTime
  );

  function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? t("PM") : t("AM");
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
  const formatedData = formatAMPM(DataDate);

  let link = singlerace.RaceResultData
    ? singlerace.RaceResultData[0]
      ? singlerace.RaceResultData[0].VideoLink
      : false
    : false;

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const formatDateAr = (dateStr) => {
    const date = new Date(dateStr);
    const options = {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    };
    return date.toLocaleDateString("ar", options);
  };

  return (
    <>
      <Zoom>
        {status !== "loading" ? (
          <div className="row RaceCardDetail" id="racedetail">
            {singlerace && singlerace.racedetail !== undefined ? (

              <div className="new-race-detail-container col-sm-12" style={{ background: 'rgb(255 255 255)' }}>

                <div className="new-race-top-header-bar" style={{ background: `${ThemeSetting?.PrimaryColor || 'rgb(10 31 67)'}` }}>
                  <div className="new-header-left-side">
                    <div className="new-header-title-group" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <span className="new-back-arrow">❮</span>
                      <h2 className="new-header-track-name">
                        {cookiedata === "en" ?
                          (singlerace.racedetail.RaceCourseData?.TrackNameEn || "-") :
                          (singlerace.racedetail.RaceCourseData?.TrackNameAr || "-")
                        }
                      </h2>
                    </div>
                    <span className="new-header-date">
                      {cookiedata === "en" ? formatDate(singlerace?.racedetail?.Day) : formatDateAr(singlerace?.racedetail?.Day)}
                    </span>
                  </div>
                  <div className="new-header-right-side">
                    <RaceNumbers racecoursedata={singlerace.racedetail === undefined ? "" : singlerace.racedetail} />
                  </div>
                </div>


                {singlerace.racedetail.RaceStatus === "Completed" ?

                  <div className="new-race-white-card-content">
                    {/* 2. Main Info Section */}
                    <div className="new-race-info-grid">
                      <div className="new-race-id-box-wrapper">
                        <div className="new-race-id-top-section" style={{
                          backgroundColor: singlerace.racedetail.RaceStatus === "Cancelled" ? "#000" :
                            singlerace.racedetail.RaceStatus === "Completed" ? "#FF0000" :
                              singlerace.racedetail.RaceStatus === "Live" ? "#5EC30F" : "#FF9900"
                        }}>
                          <span className="new-race-label">{t("Race")} {singlerace.racedetail.RaceNumber}</span>
                        </div>
                        <div className="new-race-id-bottom-section" style={{
                          backgroundColor: singlerace.racedetail.RaceStatus === "Cancelled" ? "#e0e0e0" :
                            singlerace.racedetail.RaceStatus === "Completed" ? "rgb(252 199 195)" :
                              singlerace.racedetail.RaceStatus === "Live" ? "#f1f8eb" : "#fff6ea",
                          color: singlerace.racedetail.RaceStatus === "Cancelled" ? "#000" :
                            singlerace.racedetail.RaceStatus === "Completed" ? "#FF0000" :
                              singlerace.racedetail.RaceStatus === "Live" ? "#5EC30F" : "#FF9900"
                        }}>
                          <span className="new-race-time">{formatedData.toLocaleUpperCase()}</span>
                        </div>
                      </div>

                      <div className="new-race-central-details">
                        <h3 className="new-main-race-title">
                          {cookiedata === "en" ?
                            (singlerace.racedetail.RaceNameModelData?.NameEn || "-") :
                            (singlerace.racedetail.RaceNameModelData?.NameAr || "-")
                          }
                        </h3>

                        <div className="new-stats-grid-row">
                          <div className="new-stat-column">
                            <b className="new-stat-label">{t("Race Kind")}</b>
                            <span className="new-stat-value">
                              {cookiedata === "en" ? toTitleCase(singlerace.racedetail.RaceKindData?.NameEn) : toTitleCase(singlerace.racedetail.RaceKindData?.NameAr)}
                            </span>
                          </div>
                          <div className="new-stat-column">
                            <b className="new-stat-label">{t("Race Type")}</b>
                            <span className="new-stat-value new-red-text">
                              {cookiedata === "en" ? toTitleCase(singlerace.racedetail.RaceTypeModelData?.NameEn) : toTitleCase(singlerace.racedetail.RaceTypeModelData?.NameAr)}
                            </span>
                          </div>
                          <div className="new-stat-column">
                            <b className="new-stat-label">{t("Horse Kind")}</b>
                            <span className="new-stat-value new-red-text">
                              {cookiedata === "en" ? toTitleCase(singlerace.racedetail.HorseKindinRaceData?.NameEn) : toTitleCase(singlerace.racedetail.HorseKindinRaceData?.NameAr)}
                            </span>
                          </div>
                          <div className="new-stat-column">
                            <b className="new-stat-label">{t("Total Prize")}</b>
                            <span className="new-stat-value">
                              {cookiedata === "en" ? singlerace.racedetail.CurrencyData?.NameEn : singlerace.racedetail.CurrencyData?.NameAr} {' '}
                              {(singlerace.racedetail.FirstPrice + singlerace.racedetail.SecondPrice + singlerace.racedetail.ThirdPrice + singlerace.racedetail.FourthPrice + singlerace.racedetail.FifthPrice + singlerace.racedetail.SixthPrice).toLocaleString()}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="new-race-sponsor-logo">
                        {singlerace.racedetail.SponsorData ? (
                          <a href={singlerace.racedetail.SponsorData.Url} target="_blank" rel="noreferrer">
                            <img src={singlerace.racedetail.SponsorData.image || Defaultimg2} alt="sponsor" />
                          </a>
                        ) : (
                          <img src={Defaultimg2} alt="default" />
                        )}
                      </div>
                    </div>

                    {/* 3. Middle Section: Video, Description and Map */}
                    <div className="new-race-visual-section">
                      <div className="new-visual-left-content">
                        <div className="new-thumbnail-box">
                          {singlerace.racedetail.RaceimagesData?.length > 0 ? (
                            <img src={singlerace?.racedetail?.RaceimagesData[0]?.image} className="new-race-thumbnail-img" alt="race" />
                          ) : (
                            <img src={Defaultimg2} className="new-race-thumbnail-img" alt="race" />
                          )}
                        </div>
                        <div className="new-text-details-wrapper">
                          <div className="new-running-time-block">
                            <h4 className="new-rt-value-red">{singlerace.racedetail.RaceTimeAcheived || "01:44.72"}</h4>
                            <span className="new-rt-label-gray">{t("RunningTime")}</span>
                          </div>
                          <div className="new-description-block">
                            <h5 className="new-desc-heading">{t("Description")}</h5>
                            <p className="new-desc-text">
                              {cookiedata === "en" ? toTitleCase(singlerace.racedetail.DescriptionEn) : toTitleCase(singlerace.racedetail.DescriptionAr)}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="new-visual-right-track">
                        <div className="new-track-align-box">
                          <span className="new-track-label-text">
                            {t("Track length")} : <b>{singlerace?.racedetail?.TrackLengthData?.TrackLength || "1600"}</b>
                          </span>
                          <div className="new-map-image-wrapper">
                            <img src={singlerace.racedetail.TrackLengthData?.RaceCourseImage ?? Defaultimg2} alt="track map" className="new-track-map-img" />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* 4. Trophy Prize Section */}
                    <div className="new-prize-bar-container" style={{ backgroundImage: "url('/./src/Webiste/assets/Auth/pages_bg.jpg')" }}>
                      <div className="new-prize-overlay">
                        <div className="new-podium-visual-side">
                          <img src={img1} alt="Podium" className="new-podium-main-img" />
                        </div>
                        {/* <div className="new-prize-items-wrapper">
                          {[1, 2, 3, 4, 5, 6].map((pos) => {
                            const priceKey = pos === 1 ? 'FirstPrice' : pos === 2 ? 'SecondPrice' : pos === 3 ? 'ThirdPrice' : pos === 4 ? 'FourthPrice' : pos === 5 ? 'FifthPrice' : 'SixthPrice';
                            if (pos === 6 && singlerace.racedetail.SixthPrice === 0) return null;
                            return (
                              <div className="new-prize-column" key={pos}>
                                <span className="new-prize-pos-label">
                                  {pos === 1 ? t("1st") : pos === 2 ? t("2nd") : pos === 3 ? t("3rd") : pos === 4 ? t("4th") : pos === 5 ? t("5th") : t("6th")}
                                </span>
                                <div className="new-prize-amount-value">
                                  <b>{formatNumber(singlerace.racedetail[priceKey])}</b>
                                  &nbsp;
                                  {cookiedata === "en" ? singlerace.racedetail.CurrencyData?.NameEn : singlerace.racedetail.CurrencyData?.NameAr}
                                </div>
                              </div>
                            );
                          })}
                        </div> */}
                      </div>
                    </div>
                  </div>
                  :

                  <div className="modern-race-card-content">
                    {/* 2. Modern Header Layout for Upcoming Races (Isolated) */}
                    <div className="modern-race-info-grid">
                      <div className="modern-race-id-box theme-orange">
                        <div className="new-race-id-top-section">
                          <span className="new-race-label">{t("Race")} {singlerace.racedetail.RaceNumber}</span>
                        </div>
                        <div className="new-race-id-bottom-section">
                          <span className="new-race-time">{formatedData.toLocaleUpperCase()}</span>
                        </div>
                      </div>

                      {/* <div className="modern-central-details">
                        <h3 className="new-main-race-title">
                          {cookiedata === "en" ?
                            (singlerace.racedetail.RaceNameModelData?.NameEn || "-") :
                            (singlerace.racedetail.RaceNameModelData?.NameAr || "-")
                          }
                        </h3>

                        <div className="modern-stats-row">
                          <div className="new-stat-column">
                            <b className="new-stat-label">{t("Race Kind")}</b>
                            <span className="new-stat-value">
                              {cookiedata === "en" ? toTitleCase(singlerace.racedetail.RaceKindData?.NameEn) : toTitleCase(singlerace.racedetail.RaceKindData?.NameAr)}
                            </span>
                          </div>
                          <div className="new-stat-column">
                            <b className="new-stat-label">{t("Race Type")}</b>
                            <span className="new-stat-value new-red-text" style={{ color: 'red' }}>
                              {cookiedata === "en" ? toTitleCase(singlerace.racedetail.RaceTypeModelData?.NameEn) : toTitleCase(singlerace.racedetail.RaceTypeModelData?.NameAr)}
                            </span>
                          </div>
                          <div className="new-stat-column">
                            <b className="new-stat-label">{t("Horse Kind")}</b>
                            <span className="new-stat-value new-red-text" style={{ color: 'red' }}>
                              {cookiedata === "en" ? toTitleCase(singlerace.racedetail.HorseKindinRaceData?.NameEn) : toTitleCase(singlerace.racedetail.HorseKindinRaceData?.NameAr)}
                            </span>
                          </div>
                        </div>

                        <div className="modern-stats-row" style={{ marginTop: '15px' }}>
                          <div className="new-stat-column" style={{ width: '300px' }}>
                            <b className="new-stat-label">{t("Description")}</b>
                            <span className="new-stat-value" style={{ fontSize: '15px', fontWeight: '400' }}>
                              {cookiedata === "en" ? toTitleCase(singlerace.racedetail.DescriptionEn) : toTitleCase(singlerace.racedetail.DescriptionAr)}
                            </span>
                          </div>
                          <div className="new-stat-column">
                            <b className="new-stat-label">{t("Total Prize")}</b>
                            <span className="new-stat-value new-blue-text" style={{ color: '#1a73e8' }}>
                              {cookiedata === "en" ? singlerace.racedetail.CurrencyData?.NameEn : singlerace.racedetail.CurrencyData?.NameAr} {' '}
                              {(singlerace.racedetail.FirstPrice + singlerace.racedetail.SecondPrice + singlerace.racedetail.ThirdPrice + singlerace.racedetail.FourthPrice + singlerace.racedetail.FifthPrice + singlerace.racedetail.SixthPrice).toLocaleString()}
                            </span>
                          </div>
                        </div>
                      </div> */}

                      <div className="modern-visual-block">
                        <div className="modern-visual-row">
                          {singlerace.racedetail.TrackLengthData?.RaceCourseImage ? (
                            <img src={singlerace.racedetail.TrackLengthData.RaceCourseImage} alt="track map" className="modern-header-img" />
                          ) : (
                            <img src={Defaultimg2} alt="track map" className="modern-header-img" />
                          )}
                          {singlerace.racedetail.SponsorData ? (
                            <a href={singlerace.racedetail.SponsorData.Url} target="_blank" rel="noreferrer">
                              <img src={singlerace.racedetail.SponsorData.image || Defaultimg2} alt="sponsor" className="modern-header-img" />
                            </a>
                          ) : (
                            <img src={Defaultimg2} alt="sponsor" className="modern-header-img" />
                          )}
                        </div>
                        <span className="modern-track-label">
                          {t("Track length")} : <b>{singlerace?.racedetail?.TrackLengthData?.TrackLength || "1600"}</b>
                        </span>
                      </div>
                    </div>
                  </div>

                }


                {/* 5. Navigation Tabs Section */}
                <div className="new-race-tabs-section">
                  <div className="new-tabs-header-wrap">
                    <Tabs activeKey={activeTab} onSelect={handleTabChange} defaultActiveKey="Card" className="custom-size new-styled-tabs" unmountOnExit>

                      <Tab eventKey="Card" title={t("Card")}>
                        <CardData />
                      </Tab>


                      {singlerace?.racedetail?.RaceStatus === "Live" && (
                        <Tab eventKey="Predictor" title={t("Predictor")}>
                          <div className="RaceDetailCard new-table-scroll-wrapper">
                            <div className="new-inner-scroll-content">
                              <Predictor RacePredictor={RacePredictor} />
                            </div>
                          </div>
                        </Tab>
                      )}

                      <Tab eventKey="Draw" title={t("Draw")}>
                        <div className="custom-size RaceDetailCard new-table-scroll-wrapper">
                          <div className="new-inner-scroll-content">
                            <Draw draw={draw} />
                          </div>
                        </div>
                      </Tab>

                      <Tab eventKey="Summary" title={t("Summary")}>
                        <div className="custom-size RaceDetailCard new-table-scroll-wrapper">
                          <div className="new-inner-scroll-content">
                            <Summary summary={summary} />
                          </div>
                        </div>
                      </Tab>

                      <Tab eventKey="Track Record" title={t("TrackRecord")}>
                        <div className="custom-size RaceDetailCard new-table-scroll-wrapper">
                          <div className="new-inner-scroll-content">
                            <TrackRecord1 TrackRecord={TrackRecord} />
                          </div>
                        </div>
                      </Tab>

                      <Tab eventKey="RAAS AI" title={t("RAAS AI")}>
                        <div className="custom-size RaceDetailCard new-table-scroll-wrapper">
                          <div className="new-inner-scroll-content">
                            <AiAnalysis
                              raceAiAnalysis={raceAiAnalysis}
                              aiStatus={aiAnalysisStatus}
                              aiErrorMessage={aiAnalysisErrorMessage}
                            />
                          </div>
                        </div>
                      </Tab>

                    </Tabs>
                  </div>
                </div>
              </div>

            ) : (
              <div className="NAclass RaceCardDetail">
                <Lottie animationData={Animate} className="Lottie compLottie" />
              </div>
            )}
          </div>
        ) : (
          <h2 className="RaceCardDetail">
            <Lottie
              animationData={Animate}
              loop={true}
              className="TableLottie"
            />
          </h2>
        )}
      </Zoom>

      <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body>
          <VideoFrame data={modaldata} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <Modal show={showCast} onHide={handleCloseCast} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body>
          <CastModal data={{ modaldataCast, handleCloseCast }} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};


export default RaceCardDetail;